import React from "react";
import CustomLink from "@/bit/components/next13.components.custom-link";
import Text from "@/bit/components/next13.components.text";

const Breadcrumb = (props) => {
  const { breadcrumb } = props;
  if (!breadcrumb) {
    return null;
  }
  const items = Object.entries(breadcrumb["breadCrumbs"]);
  let i = 0;
  return (
    <>
      <nav>
        <ul className="breadcrumb" data-cy="Header breadcrumb">
          {items.map(([key, value]) => {
            const link = value ? value : "#";
            const text = key;
            return (
              <li
                key={`item-${i++}`}
                className={`breadcrumb-item breacrumb-item-value-${text.toLowerCase()}`}
              >
                <CustomLink
                  href={link}
                  title=""
                  ariaLabel=""
                  taggingInfo={{
                    componentName: "header",
                    componentContent: text,
                    componentVariation: "breadcrumb",
                    componentPerso: "",
                    componentProduct: "",
                  }}
                >
                  <Text
                    text={text}
                    fontType="font-regular"
                    size="caption03"
                    color="grey6"
                    display="inline"
                  />
                </CustomLink>
              </li>
            );
          })}

          <li className="breadcrumb-item active">
            <Text
              text={breadcrumb.title}
              fontType="font-regular"
              size="caption03"
              color="grey5"
              display="inline"
            />
          </li>
        </ul>
        <style jsx>{`.breadcrumb {
  display: flex;
  line-height: 1.188rem;
  .breadcrumb-item {
    &.active {
      :global(.text) {
        font-size: 0.75rem;
      }
    }
    :global(a) {
      :global(.text) {
        font-size: 0.75rem;
      }
      &:hover {
        text-decoration: underline;
      }
    }

    &:nth-last-child(n + 3) {
      display: none;
    }

    &:not(:last-child)::after {
      display: inline-block;
      padding-right: 0.5rem;
      padding-left: 0.5rem;
      color: #6c757d;
      content: "/";
    }
  }
}

@media screen and (min-width: 768px) {
  .breadcrumb {
    .breadcrumb-item {
      &:nth-last-child(n + 3) {
        display: inline;
      }
      :global(.text) {
        font-size: 0.875rem;
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .breadcrumb {
    .breadcrumb-item {
      &.active {
        :global(.text) {
          font-size: 1rem;
        }
      }
      :global(a) {
        :global(.text) {
          font-size: 1rem;
        }
      }
    }
  }
}`}</style>
      </nav>
    </>
  );
};
export default Breadcrumb;
